module.exports = __webpack_public_path__ + "static/media/instagram.d52b637b.png";